import { useContext, useEffect, useState } from "react";
import { requester } from "App";
import { useParams } from "react-router-dom";
import P from "components/P";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VendorStockList from "./VendorStockList";
import style from "./VendorStoreStock.module.css"

function Vendoritemstock() {
    const { storeId } = useParams();
    const [isMounted, setMounted] = useState(false);
    const [items, setItems] = useState([]);
    const [stores, setStores] = useState([]);
    const [selectedStoreIndex, setSelectedStoreIndex] = useState(null);
    const fontSize = 'max(1.2vw, 10px)';

    useEffect(() => {
        setMounted(true);
    }, []);



    useEffect(() => {
        if (isMounted) {
            requester.findAllVendorStore((result) => {
                setStores(result.data);
                console.log(result.data);
            });
        }
    }, [isMounted]);

    const getStock = (index) => {
        if (stores && stores[index]) {
            let data = {
                storeCode: stores[index].storeCode
            };
            requester.findAllVendorProducts(data, (result) => {
                setItems(result.data);
                console.log(result.data);
                setSelectedStoreIndex(index);
            });
        }
    };

    const resetSelection = () => {
        setSelectedStoreIndex(null);
    };

    const lowStockProducts = items.filter((store) => store.quantity < 5);

    return (
        <div>
            <VerticalFlex
                backgroundColor="white"
                padding="max(1vw, 10px)"
                borderRadius="1rem"
            >
                {selectedStoreIndex === null ? (
                    <>

                        <FlexChild alignItems="flex-start">
                            <P size="max(1.4vw, 10px)" padding="0 0 1rem" weight={700}>
                                매장 목록
                            </P>
                        </FlexChild>
                        <HorizontalFlex padding="0 0 1rem" gap="1rem">
                            <FlexChild>
                                <VerticalFlex>
                                    <FlexChild>
                                        {stores && stores.map((data, index) => (
                                            <div className={style.storeName} key={index} onClick={() => getStock(index)}>
                                                <P
                                                    cursor={"pointer"}

                                                    size={fontSize}
                                                >
                                                    {data.storeName}
                                                </P>
                                            </div>
                                        ))}
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                        </HorizontalFlex>
                    </>
                ) : (
                    <>
                        <FlexChild alignItems="flex-start">
                            <P
                                size="max(1.4vw, 10px)"
                                padding="0 0 1rem"
                                weight={700}
                                cursor="pointer"
                                onClick={resetSelection}
                            >
                                {"<"} 뒤로가기
                            </P>
                        </FlexChild>
                        <VendorStockList items={items} />
                    </>
                )}
            </VerticalFlex>
        </div>
    );
}
export default Vendoritemstock;
